import type { HTMLAttributes, ElementType } from 'react';

interface ContainerProps extends HTMLAttributes<HTMLElement> {
  as?: ElementType;
  /** 기본 max-w-[1440px]. 좁게 쓰려면 'narrow' = max-w-[1100px] */
  width?: 'default' | 'narrow' | 'wide' | 'full';
}

const widthClass: Record<NonNullable<ContainerProps['width']>, string> = {
  default: 'max-w-[1440px]',
  narrow: 'max-w-[1100px]',
  wide: 'max-w-[1680px]',
  full: 'max-w-none',
};

/**
 * 공통 가로 컨테이너.
 * 사이트 전역에서 사용하는 `mx-auto max-w-[1440px] px-5 sm:px-8` 패턴 통일.
 */
export function Container({
  as: Tag = 'div',
  width = 'default',
  className = '',
  children,
  ...rest
}: ContainerProps) {
  return <Tag
    className={`mx-auto w-full px-5 sm:px-8 ${widthClass[width]} ${className}`}
    {...rest}
  >
    {children}
  </Tag>
}
